/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useState, ReactElement } from 'react'
import { Formik } from 'formik'
import * as yup from 'yup'
import { Form, Alert } from 'react-bootstrap'
import API from '@aws-amplify/api'

import LoadingButton from '../../LoadingButton'

const schema = yup.object({
  feedback: yup.string().required('Feedback cannot be empty'),
})

const Contact: FC<any> = props => {
  const { userinfo } = props
  const [isLoading, setIsLoading] = useState(false)
  const [submissionError, setSubmittionError] = useState('')
  const [submissionSuccess, setSubmissionSuccess] = useState(false)

  const submitFeedback = async (values: {
    feedback: string
    email: string
    name: string
    phone: string
  }): Promise<void> => {
    setIsLoading(true)

    const payload = {
      body: values,
    }

    const myInit = { body: payload }

    try {
      await API.post('mav-outlook-api', '/contact/support', myInit)

      setSubmissionSuccess(true)
    } catch (e) {
      console.error(e)

      setSubmittionError('Error submitting feedback')
      setSubmissionSuccess(false)
    }

    setIsLoading(false)
  }

  let content: ReactElement | null = null

  if (submissionSuccess) {
    content = (
      <>
        <h3>Thanks for reaching out!</h3>
        <p>We will be in touch soon.</p>
      </>
    )
  } else {
    content = (
      <>
        <h3>No time to chat live?</h3>
        <p>Leave our flight crew a note and we will get back to you soon.</p>
        {submissionError && (
          <Alert variant="danger">
            <span>{submissionError}</span>
          </Alert>
        )}
        <Formik
          validationSchema={schema}
          onSubmit={submitFeedback}
          initialValues={{
            feedback: '',
            email: userinfo.email,
            phone: '',
            name: '',
          }}
        >
          {({ handleSubmit, values, handleChange, touched, errors, submitCount }): ReactElement => (
            <Form noValidate onSubmit={handleSubmit} className="form">
              <Form.Group controlId="lastName">
                <Form.Row>
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    required
                    value={values.name}
                    onChange={handleChange}
                    isValid={touched.name && !errors.name}
                    isInvalid={submitCount > 0 && !!errors.name}
                    placeholder="name"
                  />
                </Form.Row>
              </Form.Group>
              <Form.Group controlId="email">
                <Form.Row>
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="text"
                    required
                    value={values.email}
                    onChange={handleChange}
                    isValid={touched.email && !errors.email}
                    isInvalid={submitCount > 0 && !!errors.email}
                    placeholder="firstlastname@domain.com"
                  />
                </Form.Row>
                <Form.Control.Feedback type="invalid">
                  <Alert variant="danger">{errors.email}</Alert>
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="phone">
                <Form.Row>
                  <Form.Label>Phone</Form.Label>
                  <Form.Control
                    type="text"
                    required
                    value={values.phone}
                    onChange={handleChange}
                    isValid={touched.phone && !errors.phone}
                    isInvalid={submitCount > 0 && !!errors.phone}
                    placeholder="123.123.1234"
                  />
                </Form.Row>
              </Form.Group>
              <Form.Group controlId="feedback">
                <Form.Control
                  as="textarea"
                  rows={10}
                  autoFocus
                  required
                  value={values.feedback}
                  onChange={handleChange}
                  isValid={touched.feedback && !errors.feedback}
                  isInvalid={submitCount > 0 && !!errors.feedback}
                />
                <Form.Control.Feedback type="invalid">
                  <Alert variant="danger">{errors.feedback}</Alert>
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="actions">
                <LoadingButton variant="primary" block isLoading={isLoading} type="submit">
                  Submit
                </LoadingButton>
              </Form.Group>
            </Form>
          )}
        </Formik>
      </>
    )
  }

  return <div className="contact">{content}</div>
}

export default Contact
